import React__default, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';
import Icon from '../Icon/Icon.js';

var propTypes = {
  children: PropTypes.node.isRequired,
  closeButtonLabel: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  ariaLabel: PropTypes.string,
  ariaLabelledBy: PropTypes.string,
  classList: PropTypes.string,
  heading: PropTypes.node,
  isOpen: PropTypes.bool,
  labelText: PropTypes.string,
  onClose: PropTypes.func,
  onFocus: PropTypes.func,
  onKeyDown: PropTypes.func,
  onKeyUp: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onOverlayClick: PropTypes.func
};
var Dialog = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var ariaLabel = _ref.ariaLabel,
    _ref$ariaLabelledBy = _ref.ariaLabelledBy,
    ariaLabelledBy = _ref$ariaLabelledBy === void 0 ? null : _ref$ariaLabelledBy,
    children = _ref.children,
    closeButtonLabel = _ref.closeButtonLabel,
    _ref$classList = _ref.classList,
    classList = _ref$classList === void 0 ? '' : _ref$classList,
    _ref$heading = _ref.heading,
    heading = _ref$heading === void 0 ? undefined : _ref$heading,
    id = _ref.id,
    isOpen = _ref.isOpen,
    _ref$labelText = _ref.labelText,
    labelText = _ref$labelText === void 0 ? null : _ref$labelText,
    _ref$onClose = _ref.onClose,
    onClose = _ref$onClose === void 0 ? undefined : _ref$onClose,
    _ref$onFocus = _ref.onFocus,
    onFocus = _ref$onFocus === void 0 ? undefined : _ref$onFocus,
    _ref$onKeyDown = _ref.onKeyDown,
    onKeyDown = _ref$onKeyDown === void 0 ? undefined : _ref$onKeyDown,
    _ref$onKeyUp = _ref.onKeyUp,
    onKeyUp = _ref$onKeyUp === void 0 ? undefined : _ref$onKeyUp,
    _ref$onMouseLeave = _ref.onMouseLeave,
    onMouseLeave = _ref$onMouseLeave === void 0 ? null : _ref$onMouseLeave,
    _ref$onOverlayClick = _ref.onOverlayClick,
    onOverlayClick = _ref$onOverlayClick === void 0 ? undefined : _ref$onOverlayClick;
  document.documentElement.setAttribute('data-scroll-lock', isOpen ? 'true' : 'false');
  return /*#__PURE__*/createPortal(isOpen ? /*#__PURE__*/React__default.createElement("div", {
    className: "dialog ".concat(classList, " "),
    onClick: onOverlayClick,
    ref: ref,
    role: "button",
    onFocus: onFocus,
    onKeyUp: onKeyUp,
    onKeyDown: onKeyDown,
    tabIndex: -1
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "dialog-wrapper",
    "data-testid": "dialog-wrapper"
  }, /*#__PURE__*/React__default.createElement("button", {
    "aria-hidden": "true",
    className: "jsx-tab-buffer screen-reader-text",
    "data-testid": "first-tab-buffer"
  }), /*#__PURE__*/React__default.createElement("div", {
    "aria-label": ariaLabel || labelText,
    "aria-labelledby": ariaLabelledBy,
    "aria-modal": isOpen,
    className: "dialog-container",
    id: id,
    onMouseLeave: onMouseLeave,
    role: "dialog",
    tabIndex: -1
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "dialog-block"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "dialog-heading ".concat(heading ? 'dialog-with-heading' : 'dialog-without-heading')
  }, heading, /*#__PURE__*/React__default.createElement("button", {
    "aria-label": closeButtonLabel,
    className: "dialog-close-button",
    onClick: onClose,
    type: "button"
  }, /*#__PURE__*/React__default.createElement(Icon, {
    icon: "close-thin"
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "dialog-content"
  }, children))), /*#__PURE__*/React__default.createElement("button", {
    "aria-hidden": "true",
    className: "jsx-tab-buffer screen-reader-text",
    "data-testid": "last-tab-buffer"
  }))) : null, document.body);
});
Dialog.propTypes = propTypes;

export { Dialog as default };
//# sourceMappingURL=Dialog.js.map
